/**
 * @desc 招投标公告
 */
import lodash from 'lodash';
import { computed } from 'mobx';
import { EnumAPI } from '../../apis';
import { AjaxBasics } from '../../helpers/ajaxBasics';
import { BaseModel, BasesController } from '../bases';
export class NoticeController<T = any> extends BasesController<T> {
  constructor() {
    super({
      dataKey: 'id',
      infinite: true,
      details: EnumAPI.usersvr_noticeDetail,
      pagination: EnumAPI.usersvr_noticeList,
      paginationParams: {
        currentKey: 'curPageNo',
        pageSizeKey: 'pageSize',
        filterKey: 'search',
        defaultPageSize: 5,
        response: {
          dataSource: 'recordList',
          total: 'recordCount',
        },
      },
    });
  }
  /**
   * 值存储
   * @memberof MaterialsController
   */
  Model = new BaseModel({ type: 'object' });

  /**
   * @dec 招投标公告列表
   */
  @computed
  get noticeList(): Array<any> {
    return this.Model.get('noticeList', []);
  }

  /**
   * 招投标公告
   */
  async getNoticeList() {
    try {
      const res = await AjaxBasics.request({
        ...EnumAPI.usersvr_noticeList,
        body: {
          pageSize: 5,
          curPageNo: 1,
        },
      });
      this.Model.merge({ noticeList: lodash.get(res, 'recordList') });
    } catch (error) {}
  }
}
